import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["nav-tag", { 'nav-tag-active': _ctx.actived }]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.closable)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "nav-tag-closable",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["stop"]))
        }))
      : _createCommentVNode("", true)
  ], 2))
}